import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=d4f54bc0&scoped=true&"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=ts&"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f54bc0",
  null
  
)

export default component.exports